module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "BookartSelect"
  }, _vm._l((_vm.model.options), function(option, optI) {
    return _c('option', {
      domProps: {
        "value": optI
      }
    }, [_vm._v(_vm._s(option.name))])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-047b0644!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookartCategory/BookartSelect/BookartSelect.vue
// module id = 185
// module chunks = 2